export enum SubscriptType {
  'сгор' = 'сгор',
  'несгор' = 'несгор',
  'хорео' = 'хорео',
}

// export let SubscriptType: any

